import React, { useState, useMemo } from 'react';
import './EmployeeSearch.css';

function EmployeeSearch({ 
  employees, 
  onEmployeeSelect, 
  selectedEmployee, 
  onBackToCompany, 
  months,
  onMonthsChange,
  company 
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [showRegularOnly, setShowRegularOnly] = useState(true);

  // 자음 검색을 위한 초성 매핑
  const getChoseong = (str) => {
    const choseong = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];
    const hangul = ['가', '까', '나', '다', '따', '라', '마', '바', '빠', '사', '싸', '아', '자', '짜', '차', '카', '타', '파', '하'];
    
    let result = '';
    for (let char of str) {
      const code = char.charCodeAt(0);
      if (code >= 44032 && code <= 55203) { // 한글 범위
        const index = Math.floor((code - 44032) / 588);
        result += choseong[index];
      } else {
        result += char;
      }
    }
    return result;
  };

  // 필터링된 직원 목록
  const filteredEmployees = useMemo(() => {
    return employees.filter(employee => {
      const matchesSearch = searchTerm === '' || 
        employee.name.includes(searchTerm) || 
        getChoseong(employee.name).includes(searchTerm);
      
      const matchesContractType = !showRegularOnly || 
        employee.contract_type === '상용직';
      
      return matchesSearch && matchesContractType;
    });
  }, [employees, searchTerm, showRegularOnly]);


  return (
    <div className="employee-search">
      <div className="search-header">
        <div className="header-top">
          <button 
            className="back-btn"
            onClick={onBackToCompany}
            title="기업 선택으로 돌아가기"
          >
            ← 기업 선택
          </button>
          <h3>직원 검색</h3>
        </div>
        <div className="company-info">
          <span className="company-name">{company?.name}</span>
          {company?.alt_name && company.alt_name !== company.name && (
            <span className="company-alt-name">({company.alt_name})</span>
          )}
        </div>
        <div className="search-stats">
          총 {employees.length}명 중 {filteredEmployees.length}명 표시
        </div>
      </div>

      <div className="period-controls">
        <div className="period-group">
          <label className="period-label">조회 기간:</label>
          <div className="period-toggle" role="group" aria-label="조회 기간">
            {[1, 3, 6, 12, 24, 60].map((m) => (
              <button
                type="button"
                key={m}
                className={months === m ? 'on' : ''}
                aria-pressed={months === m}
                title={`최근 ${m}개월 대장에 있던 직원`}
                onClick={() => onMonthsChange(m)}
              >
                {m}개월
              </button>
            ))}
          </div>
        </div>
        <div className="contract-type-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={showRegularOnly}
              onChange={(e) => setShowRegularOnly(e.target.checked)}
              className="contract-type-checkbox"
            />
            <span className="checkbox-text">상용직만</span>
          </label>
        </div>
      </div>

      <div className="search-controls">
        <div className="search-input-group">
          <input
            type="text"
            placeholder="직원명 또는 초성으로 검색"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          {searchTerm && (
            <button 
              className="clear-search-btn"
              onClick={() => setSearchTerm('')}
              title="검색어 지우기"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      <div className="employee-results">
        {filteredEmployees.length > 0 ? (
          <div className="employee-list">
            {filteredEmployees.map(employee => {
              const employeeKey = employee.employee_id || employee.contract_key;
              const selectedKey = selectedEmployee ? (selectedEmployee.employee_id || selectedEmployee.contract_key) : null;
              return (
              <div
                key={employeeKey}
                className={`employee-item ${selectedKey === employeeKey ? 'selected' : ''}`}
                onClick={() => onEmployeeSelect(employee)}
              >
              <div className="employee-content">
                <div className="employee-main-info">
                  <span className="contract-type">{employee.contract_type}</span>
                  <span className="employee-name">{employee.name}</span>
                  <span className="employee-id">{employee.id_number}</span>
                </div>
              </div>
              </div>
              );
            })}
          </div>
        ) : (
          <div className="no-results">
            <div className="no-results-icon">👥</div>
            <p>검색 결과가 없습니다.</p>
            <p className="no-results-hint">
              {searchTerm || showRegularOnly ? '검색 조건을 변경해보세요.' : '해당 기간에 등록된 직원이 없습니다.'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmployeeSearch;
